import { useState } from 'react';

export default function Newsletter() {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      return;
    }

    try {
      const res = await fetch('https://readdy.ai/api/form/d9tvtk53pcjqs2fcsjkg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(
          Array.from(formData.entries())
            .filter(([key]) => key !== 'phone_alt')
            .map(([key, value]) => [key, String(value)])
        ).toString(),
      });

      const responseText = await res.text();
      let parsed: any;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        form.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后重试';
        if (typeof msg === 'string' && msg.toLowerCase().includes('spam')) {
          setStatus('error');
          setErrorMsg('订阅失败，请稍后重试');
        } else {
          setStatus('error');
          setErrorMsg(msg);
        }
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请检查网络连接后重试');
    }
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-primary-500">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-background-50">
          订阅我们的简报
        </h2>
        <p className="mt-2 text-background-100/80 text-sm">
          每周获取最新的跨文化时尚、美妆和生活方式深度内容，发现属于你的风格密码。
        </p>

        {status === 'success' ? (
          <div className="mt-8 p-6 rounded-lg bg-background-50/10 border border-background-50/20">
            <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-background-50/20">
              <i className="ri-check-line text-2xl text-background-50"></i>
            </div>
            <p className="mt-3 text-background-50 font-medium">感谢订阅！</p>
            <p className="mt-1 text-sm text-background-100/70">我们会将最新内容发送到你的邮箱。</p>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            data-readdy-form
            className="mt-8 flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="honeypot-field"
            />
            <input
              type="email"
              name="email"
              required
              placeholder="输入你的邮箱地址"
              className="flex-1 px-5 py-3 rounded-full bg-background-50 text-foreground-800 text-sm placeholder:text-foreground-400 border border-background-200/70 focus:outline-none focus:ring-2 focus:ring-background-50/30"
            />
            <button
              type="submit"
              className="whitespace-nowrap px-8 py-3 rounded-full bg-foreground-900 text-background-50 font-medium text-sm hover:bg-foreground-800 transition-colors cursor-pointer"
            >
              立即订阅
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="mt-3 text-sm text-background-100/90">{errorMsg}</p>
        )}
        <p className="mt-3 text-xs text-background-100/50">
          我们尊重你的隐私，不会发送垃圾邮件，你可以随时取消订阅。
        </p>
      </div>
    </section>
  );
}